var _rect, _line, _line2, _line3, _line4, _line5, _line6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 56,
    height: 56,
    rx: 3,
    stroke: "#C75E5A",
    strokeWidth: 2,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: 28,
    x2: 42,
    y2: 84,
    stroke: "#C75E5A",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 28,
    x2: 56,
    y2: 84,
    stroke: "#C75E5A",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 28,
    x2: 70,
    y2: 84,
    stroke: "#C75E5A",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 42,
    x2: 84,
    y2: 42,
    stroke: "#C75E5A",
    strokeWidth: 1.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 56,
    x2: 84,
    y2: 56,
    stroke: "#C75E5A",
    strokeWidth: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 70,
    x2: 84,
    y2: 70,
    stroke: "#C75E5A",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 28,
    width: 14,
    height: 14,
    fill: "#FAC1B5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 42,
    width: 14,
    height: 14,
    fill: "#FAC1B5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 42,
    width: 14,
    height: 14,
    fill: "#FAC1B5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 42,
    width: 14,
    height: 14,
    fill: "#FAC1B5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 56,
    width: 14,
    height: 14,
    fill: "#FAC1B5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 70,
    width: 14,
    height: 14,
    fill: "#FAC1B5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 56,
    width: 14,
    height: 14,
    fill: "#FAC1B5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 39,
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#F9907B",
    textAnchor: "middle"
  }, "1")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 53,
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#F9907B",
    textAnchor: "middle"
  }, "3")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 16,
    y: 67,
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#F9907B",
    textAnchor: "middle"
  }, "1")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 67,
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#F9907B",
    textAnchor: "middle"
  }, "1")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 81,
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#F9907B",
    textAnchor: "middle"
  }, "1")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 24,
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#F9907B",
    textAnchor: "middle"
  }, "1")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 49,
    y: 24,
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#F9907B",
    textAnchor: "middle"
  }, "4")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 63,
    y: 24,
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#F9907B",
    textAnchor: "middle"
  }, "1")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 77,
    y: 24,
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#F9907B",
    textAnchor: "middle"
  }, "1")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonogram);
export default __webpack_public_path__ + "static/media/Nonogram.03c235f50c54cb2c935ee28d2ff6d84e.svg";
export { ForwardRef as ReactComponent };